import { connect } from "react-redux";
import { AppliedFilterTrackingProperties } from "@hopper-b2b/types";
import { IStoreState } from "../../../../../../../../reducers/types";
import { actions } from "../../../../../../actions/index";
import {
  getFlightNumberFilter,
  getDepartureDate,
  IFlightNumberFilter,
} from "../../../../../../reducer";
import {
  IFlightNumbersByAirlineCode,
  IAirlineOptions,
} from "../../../../../../../shop/reducer";
import { FlightNumberFilterSelectionComponent } from "./component";

export interface IFlightNumberFilterSelectionBase {
  allAirlines: IAirlineOptions[];
  flightNumberFilter: IFlightNumberFilter[];
  flightNumbersByAirline: IFlightNumbersByAirlineCode;
  departureDate: Date;
  showDropdownContentOnly?: boolean;
  setFlightNumberFilter: (flightNumbers: IFlightNumberFilter[]) => void;
  trackingProperties?: AppliedFilterTrackingProperties;
}

const mapStateToProps = (state: IStoreState) => {
  const departureDate = getDepartureDate(state);

  return {
    flightNumberFilter: getFlightNumberFilter(state),
    departureDate,
  };
};

const mapDispatchToProps = {
  setFlightNumberFilter: actions.setFlightNumberFilter,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const FlightNumberFilterSelection = connector(
  FlightNumberFilterSelectionComponent as (
    props: IFlightNumberFilterSelectionBase
  ) => JSX.Element
);

export default FlightNumberFilterSelection;
